var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.platform.appartisan",
  title: "EGT Platform — AppArtisan",
  description: "Capability you can trust — reviewed plugins that extend the platform, safely. The AppArtisan invitation.",
  supportServer: true,
  fields: { reserveUrl: { title: "Reserve URL", type: "uri", description: "Reservation entry point.", required: false } }
});
var P = require("../helpers/egt.platform.sections.js");

exports.render = async function render(options) {
  var reserve = (options && options.reserveUrl) || "/reserve";
  return P.capabilityPage({
    id: "appartisan", reserve: reserve,
    media: { img: "/imgs/egt-platform-nexus.jpg", alt: "", parallax: 0.06 },
    eyebrow: "The Universe Platform · AppArtisan",
    title: [ "Capability ", { n: "br" }, "you can ", { n: "span", c: "egt__gold", i: "trust." } ],
    /* first paragraph = the crisp definition of the term (SEO wave 2C-6) */
    lead: "AppArtisan is the reviewed plugin program for the Universe Platform by EGT. Plugins extend what your business can do — without becoming a back door. Every capability is reviewed before it can touch a single account.",
    /* SEO wave 2C-5/2C-7 (2026-10-09): answer-first definition, who it's for,
     * and straight answers drawn only from objections the site already answers. */
    answer: "Builders use AppArtisan to extend the Universe Platform by EGT; businesses use it to add capability without adding risk, because every plugin is reviewed before it runs and scoped to only what it needs. It's part of the public beta.",
    forTitle: "For the businesses that use it — and the builders who make it.",
    forWho: [
      { title: "Businesses that need one more capability", copy: "Add what your business needs without opening a back door — nothing reaches your account until it has earned the right to." },
      { title: "Owners who care about access", copy: "Add-ons get exactly the reach they need to do their job, and nothing beyond it." },
      { title: "Engineers and AppArtisans", copy: "Build real capability for real businesses, on a system that takes trust seriously." }
    ],
    faq: [
      [ "Is every plugin reviewed?",
        "Yes. Every plugin moves through review before it can run. Capability is welcome; unvetted access is not." ],
      [ "Can a plugin reach my whole account?",
        "No. Add-ons are scoped to exactly the reach they need to do their job — never blanket access." ],
      [ "I build software. Is there a place for me?",
        "Yes. If you build, we'd love to meet you — there's a place for your craft here." ]
    ],
    spineEyebrow: "What it does",
    spineTitle: "More power, gated by trust.",
    spineLead: "An open platform is only as safe as its weakest add-on — so nothing reaches you until it has earned the right to.",
    points: [
      { title: "Reviewed first", copy: "Every plugin moves through review before it can run. Capability is welcome; unvetted access is not." },
      { title: "Scoped, never blanket", copy: "Add-ons get exactly the reach they need to do their job — and nothing beyond it." },
      { title: "A door for builders", copy: "Engineers and AppArtisans: there's a place for your craft here. Build real capability for real businesses, on a system that takes trust seriously." }
    ],
    honesty: "For the builders among us.",
    honestyLead: "If you build, we'd love to meet you — capability is welcome; unvetted access is not.",
    honestyMedia: { img: "/imgs/egt-platform-nexus.jpg", alt: "", parallax: true }
  });
};
